import { Swiper } from 'swiper';
import { EffectFade, Navigation, A11y } from 'swiper/modules';
import 'swiper/css';


const testimonialsSlider = document.querySelectorAll('.testimonials');

document.addEventListener('DOMContentLoaded', () => {
	testimonialsSlider.forEach((slider) => {
		console.log(slider)
		let swiperSettings = {
			modules: [Navigation, A11y, EffectFade],
			a11y: true,
			grabCursor: true,
			slidesPerView: 'auto',
			freeMode: false,
			speed: 400,
			effect: 'fade',
			loop: true,
			keyboard: {
				enabled: true,
			},
			navigation: {
				nextEl: `.testimonials .swiper-btn-next`,
				prevEl: `.testimonials .swiper-btn-prev`,
			}
		};

		new Swiper(slider, swiperSettings);
  });
});
